import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Input — input estilizado con foco corporativo.
 *
 * @example
 * <Input type="email" placeholder="email@empresa.com" />
 * <Input disabled value="No editable" />
 */
export const Input = React.forwardRef(({ className, type = "text", icon, wrapperClassName, ...props }, ref) => {
  // OJO: el padding horizontal NO va en `base`. Si pusiéramos `px-3` aquí y luego
  // `pl-9` en la rama con icono, twMerge NO los deduplica (px-3 también fija el
  // padding derecho) y el padding-left quedaría a merced del orden del CSS — que
  // difiere entre el dev server (JIT incremental) y el build. Resultado: el icono
  // se solapaba con el texto en dev. Aplicamos el padding por rama, sin conflicto.
  const base = cn(
    "flex h-9 w-full rounded-md border border-input bg-background py-1 text-sm",
    "shadow-sm transition-colors",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium",
    "placeholder:text-muted-foreground",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
    "disabled:cursor-not-allowed disabled:opacity-50"
  );

  // Con icono: lo posiciona absoluto a la izquierda y reserva hueco con pl-9 (+ pr-3).
  // El svg que se pase se normaliza a 16px. `wrapperClassName` controla el ancho.
  if (icon) {
    return (
      <div className={cn("relative", wrapperClassName)}>
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground [&_svg]:w-4 [&_svg]:h-4">
          {icon}
        </span>
        <input type={type} ref={ref} className={cn(base, "pl-9 pr-3", className)} {...props} />
      </div>
    );
  }

  return <input type={type} ref={ref} className={cn(base, "px-3", className)} {...props} />;
});
Input.displayName = "Input";
